import { gql } from '@apollo/client';
import { genericFields } from './index';

export const agencyItemsFragment = gql`
  fragment agencyItemFields on Item {
    ${genericFields}
    hasInternalLoan
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
`;
